"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApiClient_1 = __importDefault(require("../utils/ApiClient"));
var CustomerRepository = /** @class */ (function () {
    function CustomerRepository() {
    }
    CustomerRepository.getOneById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customer/".concat(id === null || id === void 0 ? void 0 : id.toString());
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    CustomerRepository.getOneByUUID = function (customerUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/storefront/customer/".concat(customerUUID);
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    CustomerRepository.create = function (entity) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/customer';
                return [2 /*return*/, ApiClient_1.default.post(url, entity)];
            });
        });
    };
    CustomerRepository.createV2 = function (entity) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/storefront/customer';
                return [2 /*return*/, ApiClient_1.default.post(url, entity)];
            });
        });
    };
    CustomerRepository.resetPassword = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/customer/resetpassword';
                return [2 /*return*/, ApiClient_1.default.post(url, { email: email })];
            });
        });
    };
    CustomerRepository.resetPasswordV2 = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/storefront/auth/customer/reset-password';
                return [2 /*return*/, ApiClient_1.default.post(url, { email: email })];
            });
        });
    };
    CustomerRepository.update = function (customerId, entity) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customer/".concat(customerId);
                return [2 /*return*/, ApiClient_1.default.put(url, entity)];
            });
        });
    };
    CustomerRepository.updateV2 = function (customerUUID, entity) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/storefront/customer/".concat(customerUUID);
                return [2 /*return*/, ApiClient_1.default.put(url, entity)];
            });
        });
    };
    CustomerRepository.updatePushNotificationsState = function (customerId, allowed) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customer/".concat(customerId.toString(), "/push");
                return [2 /*return*/, ApiClient_1.default.put(url, { allow_push_notifications: allowed })];
            });
        });
    };
    CustomerRepository.updatePushNotificationsStateV2 = function (customerUUID, allowed) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/storefront/customer/".concat(customerUUID, "/push");
                return [2 /*return*/, ApiClient_1.default.patch(url, { allow_push_notifications: allowed })];
            });
        });
    };
    CustomerRepository.checkLocation = function (customerUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/storefront/customer/".concat(customerUUID, "/check-location");
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    CustomerRepository.linkFirm = function (customerId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customer/".concat(customerId, "/checkfirm");
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    /**
     * Not used anymore for non google account
     * @param email
     * @param google
     */
    CustomerRepository.checkEmailV2 = function (email, google) {
        if (google === void 0) { google = true; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/storefront/customer/check-email';
                return [2 /*return*/, ApiClient_1.default.post(url, {
                        email: email,
                        google: google
                    })];
            });
        });
    };
    CustomerRepository.checkEmail = function (email, google) {
        if (google === void 0) { google = true; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/customer/checkemail';
                return [2 /*return*/, ApiClient_1.default.post(url, {
                        email: email,
                        google: google
                    })];
            });
        });
    };
    CustomerRepository.checkActivation = function (customerId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customer/".concat(customerId, "/checkactivation");
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    CustomerRepository.initSocialLogin = function (socialMedia) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customer/login/".concat(socialMedia);
                return [2 /*return*/, ApiClient_1.default.post(url)];
            });
        });
    };
    CustomerRepository.checkSocialToken = function (socialToken) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/customer/check_login_sm';
                return [2 /*return*/, ApiClient_1.default.post(url, {
                        session_token: socialToken
                    })];
            });
        });
    };
    CustomerRepository.saveDeviceToken = function (customerId, deviceToken) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customer/".concat(customerId, "/device_token");
                return [2 /*return*/, ApiClient_1.default.post(url, {
                        device_token: deviceToken
                    })];
            });
        });
    };
    CustomerRepository.checkAccessToken = function (code, tokenId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/customer/app-apple-signin';
                return [2 /*return*/, ApiClient_1.default.post(url, {
                        code: code,
                        id_token: tokenId
                    })];
            });
        });
    };
    CustomerRepository.getMessages = function (customerId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customer/".concat(customerId, "/shop_messages");
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    CustomerRepository.markMessageAsRead = function (customerId, messageId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customer/".concat(customerId, "/shop_messages/").concat(messageId);
                return [2 /*return*/, ApiClient_1.default.put(url)];
            });
        });
    };
    CustomerRepository.getCustomerAddresses = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customers/".concat(uuid, "/addresses");
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    CustomerRepository.updateCustomerAddress = function (uuid, address) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_b) {
                url = "/customers/".concat(uuid, "/addresses/").concat(address.id);
                return [2 /*return*/, ApiClient_1.default.put(url, {
                        is_default: address.is_default,
                        description: address.description,
                        street: address.street,
                        house_number: address.house_number,
                        bus: address.bus,
                        zip_code: address.zip_code,
                        locality: address.locality,
                        country_id: (_a = address.country) === null || _a === void 0 ? void 0 : _a.id
                    })];
            });
        });
    };
    CustomerRepository.addCustomerAddress = function (uuid, address) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_b) {
                url = "/customers/".concat(uuid, "/addresses");
                return [2 /*return*/, ApiClient_1.default.post(url, {
                        is_default: address.is_default,
                        description: address.description,
                        street: address.street,
                        house_number: address.house_number,
                        bus: address.bus,
                        zip_code: address.zip_code,
                        locality: address.locality,
                        country_id: (_a = address.country) === null || _a === void 0 ? void 0 : _a.id
                    })];
            });
        });
    };
    CustomerRepository.updateBusinessDetails = function (uuid, businessDetails) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/customer/".concat(uuid, "/vat");
                return [2 /*return*/, ApiClient_1.default.put(url, businessDetails)];
            });
        });
    };
    CustomerRepository.deleteCustomer = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiClient_1.default.delete("/customers/".concat(uuid))];
            });
        });
    };
    CustomerRepository.deleteCustomerV2 = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiClient_1.default.delete("/storefront/customer/".concat(uuid))];
            });
        });
    };
    return CustomerRepository;
}());
exports.default = CustomerRepository;
